import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  defaultFont,
} from 'assets/jss/material-dashboard-react.js';

const tableStyle = theme => ({
  warningTableHeader: {
    color: warningColor[0],
  },
  primaryTableHeader: {
    color: primaryColor[0],
  },
  dangerTableHeader: {
    color: dangerColor[0],
  },
  successTableHeader: {
    color: successColor[0],
  },
  infoTableHeader: {
    color: infoColor[0],
  },
  roseTableHeader: {
    color: roseColor[0],
  },
  grayTableHeader: {
    color: grayColor[0],
  },
  table: {
    marginBottom: '0',
    width: '100%',
    maxWidth: '100%',
    backgroundColor: 'transparent',
    borderSpacing: '0',
    borderCollapse: 'collapse',
  },
  tableHeadCell: {
    color: 'inherit',
    userSelect: 'none',
    ...defaultFont,
    '&, &$tableCell': {
      fontSize: '1em',
      cursor: 'pointer',
    },
    '& $sortIconWrapper': {
      visibility: 'hidden',
    },
    '&:hover $sortIconWrapper': {
      visibility: 'visible',
    },
  },
  tableHeadCellContent: {
    paddingRight: 27,
    position: 'relative',
  },
  tableCell: {
    ...defaultFont,
    lineHeight: '1.42857143',
    padding: '6px 24px 6px 16px',
    verticalAlign: 'middle',
    fontSize: '0.8125rem',
  },

  nowrapCell: {
    whiteSpace: 'nowrap',
  },
  sortIconWrapper: {
    position: 'absolute',
    right: 0,
    color: 'gray',
  },
  tableHeadCellSorted: {
    visibility: 'visible !important',
    color: 'white',
  },

  tableResponsive: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  tableHeadRow: {
    color: 'inherit',
    display: 'table-row',
    outline: 'none',
    verticalAlign: 'middle',
  },
  tableBodyRow: {
    color: 'inherit',
    display: 'table-row',
    outline: 'none',
    verticalAlign: 'middle',
  },
});

export default tableStyle;
